import type { FaireProductEntity } from "../../entity_types/product";

export const p_ze2mdxspej: FaireProductEntity = {
  token: "p_ze2mdxspej",
  type: "product",
  name: "'NO' Glossy 18K Gold Plated Stainless Steel Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl: "https://cdn.faire.com/fastly/cd9e902f856fae29baf7fe4820cf77590f1b5b11eef5990a585c5ed4e7bd4074.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/62575a3d2b6fd635bb91b1e92cbc6f76f01311d05abd53c79dfbdd49709d0d85.jpeg",
    "https://cdn.faire.com/fastly/08c82c3f5c142a73d131a66b8d1062cc05bcd6c1d2731c03c8bd21488478aac0.jpeg",
    "https://cdn.faire.com/fastly/ae90567643797f562b3559db43e0b3056cba5b44b1a83bd1b6a08627ada69f4d.jpeg",
    "https://cdn.faire.com/fastly/9a201143223dc0e0976b7315796e06e636846fec3f229b60357cc6b241db479a.jpeg"
  ],
  priceDollars: 4.85,
  description: "Type: Ring\nMaterial : Stainless steel ,18K gold plated\nSize : Please refer to Size chart of rings\nProcess: Vacuum electroplating and manual polishing,Non tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts\n ",
  tags: [],
  msrpDollars: 12.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:35.852Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
